import { Command } from "./Command";
import { RenderContext3D } from "../RenderContext3D";
import { LayaGL } from "../../../../layagl/LayaGL";
import { SetShaderDataCMD } from "./SetShaderDataCMD";
export class SetGlobalShaderDataCMD extends Command {
    static create(nameID, value, shaderDataType, commandBuffer) {
        let context = RenderContext3D._instance;
        let shaderData = context._contextOBJ.globalShaderData;
        if (!shaderData)
            shaderData = context._contextOBJ.globalShaderData = LayaGL.renderDeviceFactory.createShaderData(null);
        var cmd = SetShaderDataCMD.create(shaderData, nameID, value, shaderDataType, commandBuffer);
        return cmd;
    }
}
